import { render, staticRenderFns } from "./DoctorScreen.vue?vue&type=template&id=f1faf7d6&"
import script from "./DoctorScreen.vue?vue&type=script&lang=js&"
export * from "./DoctorScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports